import { Component, OnInit, Input, OnChanges, SimpleChanges } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Fournisseur } from '../../../../../models/fournisseur';
import * as Feather from 'feather-icons';

@Component({
    selector: 'app-fourniss-detail-contenue',
    templateUrl: './fourniss-detail-contenue.component.html',
    styleUrls: ['./fourniss-detail-contenue.component.scss']
})
export class FournissDetailContenueComponent implements OnInit {
    @Input() fournisseur: Fournisseur | null = null;
    @Input() isLoading: boolean = false;

    reference: string | null = null;

    constructor(
        private router: Router,
        private route: ActivatedRoute
    ) {}

    ngOnInit(): void {
        this.route.paramMap.subscribe(params => {
            this.reference = params.get('reference');
            if (this.reference && this.router.url === `/tiers/fournisseurs/details/${this.reference}/detail-contenue-document`) {
                this.router.navigate([`/tiers/fournisseurs/details/${this.reference}/detail-contenue-document/commande-fournisseur`], {
                    replaceUrl: true
                });
            }
        });
        setTimeout(() => Feather.replace(), 0);
    }


}
